"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateProjectDetailsToJSON = exports.CreateProjectDetailsFromJSONTyped = exports.CreateProjectDetailsFromJSON = exports.instanceOfCreateProjectDetails = exports.CreateProjectDetailsProjectTypeKeyEnum = exports.CreateProjectDetailsProjectTemplateKeyEnum = exports.CreateProjectDetailsAssigneeTypeEnum = void 0;
/**
 * @export
 */
exports.CreateProjectDetailsAssigneeTypeEnum = {
    ProjectLead: 'PROJECT_LEAD',
    Unassigned: 'UNASSIGNED'
};
/**
 * @export
 */
exports.CreateProjectDetailsProjectTemplateKeyEnum = {
    PyxisGreenhopperJiraghSimplifiedAgilityKanban: 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban',
    PyxisGreenhopperJiraghSimplifiedAgilityScrum: 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum',
    PyxisGreenhopperJiraghSimplifiedBasic: 'com.pyxis.greenhopper.jira:gh-simplified-basic',
    PyxisGreenhopperJiraghSimplifiedKanbanClassic: 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic',
    PyxisGreenhopperJiraghSimplifiedScrumClassic: 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic',
    PyxisGreenhopperJiraghCrossTeamTemplate: 'com.pyxis.greenhopper.jira:gh-cross-team-template',
    PyxisGreenhopperJiraghCrossTeamPlanningTemplate: 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template',
    AtlassianServicedesksimplifiedItServiceManagement: 'com.atlassian.servicedesk:simplified-it-service-management',
    AtlassianServicedesksimplifiedGeneralServiceDesk: 'com.atlassian.servicedesk:simplified-general-service-desk',
    AtlassianServicedesksimplifiedGeneralServiceDeskIt: 'com.atlassian.servicedesk:simplified-general-service-desk-it',
    AtlassianServicedesksimplifiedGeneralServiceDeskBusiness: 'com.atlassian.servicedesk:simplified-general-service-desk-business',
    AtlassianServicedesksimplifiedInternalServiceDesk: 'com.atlassian.servicedesk:simplified-internal-service-desk',
    AtlassianServicedesksimplifiedExternalServiceDesk: 'com.atlassian.servicedesk:simplified-external-service-desk',
    AtlassianServicedesksimplifiedHrServiceDesk: 'com.atlassian.servicedesk:simplified-hr-service-desk',
    AtlassianServicedesksimplifiedFacilitiesServiceDesk: 'com.atlassian.servicedesk:simplified-facilities-service-desk',
    AtlassianServicedesksimplifiedLegalServiceDesk: 'com.atlassian.servicedesk:simplified-legal-service-desk',
    AtlassianServicedesksimplifiedMarketingServiceDesk: 'com.atlassian.servicedesk:simplified-marketing-service-desk',
    AtlassianServicedesksimplifiedFinanceServiceDesk: 'com.atlassian.servicedesk:simplified-finance-service-desk',
    AtlassianServicedesksimplifiedAnalyticsServiceDesk: 'com.atlassian.servicedesk:simplified-analytics-service-desk',
    AtlassianServicedesksimplifiedDesignServiceDesk: 'com.atlassian.servicedesk:simplified-design-service-desk',
    AtlassianServicedesksimplifiedSalesServiceDesk: 'com.atlassian.servicedesk:simplified-sales-service-desk',
    AtlassianServicedesksimplifiedHalpServiceDesk: 'com.atlassian.servicedesk:simplified-halp-service-desk',
    AtlassianServicedesksimplifiedBlankProjectIt: 'com.atlassian.servicedesk:simplified-blank-project-it',
    AtlassianServicedesksimplifiedBlankProjectBusiness: 'com.atlassian.servicedesk:simplified-blank-project-business',
    AtlassianServicedesknextGenItServiceDesk: 'com.atlassian.servicedesk:next-gen-it-service-desk',
    AtlassianServicedesknextGenHrServiceDesk: 'com.atlassian.servicedesk:next-gen-hr-service-desk',
    AtlassianServicedesknextGenLegalServiceDesk: 'com.atlassian.servicedesk:next-gen-legal-service-desk',
    AtlassianServicedesknextGenMarketingServiceDesk: 'com.atlassian.servicedesk:next-gen-marketing-service-desk',
    AtlassianServicedesknextGenFacilitiesServiceDesk: 'com.atlassian.servicedesk:next-gen-facilities-service-desk',
    AtlassianServicedesknextGenGeneralServiceDesk: 'com.atlassian.servicedesk:next-gen-general-service-desk',
    AtlassianServicedesknextGenGeneralItServiceDesk: 'com.atlassian.servicedesk:next-gen-general-it-service-desk',
    AtlassianServicedesknextGenGeneralBusinessServiceDesk: 'com.atlassian.servicedesk:next-gen-general-business-service-desk',
    AtlassianServicedesknextGenAnalyticsServiceDesk: 'com.atlassian.servicedesk:next-gen-analytics-service-desk',
    AtlassianServicedesknextGenFinanceServiceDesk: 'com.atlassian.servicedesk:next-gen-finance-service-desk',
    AtlassianServicedesknextGenDesignServiceDesk: 'com.atlassian.servicedesk:next-gen-design-service-desk',
    AtlassianServicedesknextGenSalesServiceDesk: 'com.atlassian.servicedesk:next-gen-sales-service-desk',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedContentManagement: 'com.atlassian.jira-core-project-templates:jira-core-simplified-content-management',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedDocumentApproval: 'com.atlassian.jira-core-project-templates:jira-core-simplified-document-approval',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedLeadTracking: 'com.atlassian.jira-core-project-templates:jira-core-simplified-lead-tracking',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedProcessControl: 'com.atlassian.jira-core-project-templates:jira-core-simplified-process-control',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedProcurement: 'com.atlassian.jira-core-project-templates:jira-core-simplified-procurement',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedProjectManagement: 'com.atlassian.jira-core-project-templates:jira-core-simplified-project-management',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedRecruitment: 'com.atlassian.jira-core-project-templates:jira-core-simplified-recruitment',
    AtlassianJiraCoreProjectTemplatesjiraCoreSimplifiedTask: 'com.atlassian.jira-core-project-templates:jira-core-simplified-task-'
};
/**
 * @export
 */
exports.CreateProjectDetailsProjectTypeKeyEnum = {
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business'
};
/**
 * Check if a given object implements the CreateProjectDetails interface.
 */
function instanceOfCreateProjectDetails(value) {
    if (!('key' in value))
        return false;
    if (!('name' in value))
        return false;
    return true;
}
exports.instanceOfCreateProjectDetails = instanceOfCreateProjectDetails;
function CreateProjectDetailsFromJSON(json) {
    return CreateProjectDetailsFromJSONTyped(json, false);
}
exports.CreateProjectDetailsFromJSON = CreateProjectDetailsFromJSON;
function CreateProjectDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assigneeType': json['assigneeType'] == null ? undefined : json['assigneeType'],
        'avatarId': json['avatarId'] == null ? undefined : json['avatarId'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'description': json['description'] == null ? undefined : json['description'],
        'fieldConfigurationScheme': json['fieldConfigurationScheme'] == null ? undefined : json['fieldConfigurationScheme'],
        'issueSecurityScheme': json['issueSecurityScheme'] == null ? undefined : json['issueSecurityScheme'],
        'issueTypeScheme': json['issueTypeScheme'] == null ? undefined : json['issueTypeScheme'],
        'issueTypeScreenScheme': json['issueTypeScreenScheme'] == null ? undefined : json['issueTypeScreenScheme'],
        'key': json['key'],
        'lead': json['lead'] == null ? undefined : json['lead'],
        'leadAccountId': json['leadAccountId'] == null ? undefined : json['leadAccountId'],
        'name': json['name'],
        'notificationScheme': json['notificationScheme'] == null ? undefined : json['notificationScheme'],
        'permissionScheme': json['permissionScheme'] == null ? undefined : json['permissionScheme'],
        'projectTemplateKey': json['projectTemplateKey'] == null ? undefined : json['projectTemplateKey'],
        'projectTypeKey': json['projectTypeKey'] == null ? undefined : json['projectTypeKey'],
        'url': json['url'] == null ? undefined : json['url'],
        'workflowScheme': json['workflowScheme'] == null ? undefined : json['workflowScheme'],
    };
}
exports.CreateProjectDetailsFromJSONTyped = CreateProjectDetailsFromJSONTyped;
function CreateProjectDetailsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'assigneeType': value['assigneeType'],
        'avatarId': value['avatarId'],
        'categoryId': value['categoryId'],
        'description': value['description'],
        'fieldConfigurationScheme': value['fieldConfigurationScheme'],
        'issueSecurityScheme': value['issueSecurityScheme'],
        'issueTypeScheme': value['issueTypeScheme'],
        'issueTypeScreenScheme': value['issueTypeScreenScheme'],
        'key': value['key'],
        'lead': value['lead'],
        'leadAccountId': value['leadAccountId'],
        'name': value['name'],
        'notificationScheme': value['notificationScheme'],
        'permissionScheme': value['permissionScheme'],
        'projectTemplateKey': value['projectTemplateKey'],
        'projectTypeKey': value['projectTypeKey'],
        'url': value['url'],
        'workflowScheme': value['workflowScheme'],
    };
}
exports.CreateProjectDetailsToJSON = CreateProjectDetailsToJSON;
//# sourceMappingURL=CreateProjectDetails.js.map